var React = require('react');

function TwitterLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.2 2.447a7.865 7.865 0 01-2.262.62A3.946 3.946 0 0018.67.888a7.89 7.89 0 01-2.502.956A3.932 3.932 0 0013.293.6C10.75.6 8.88 2.973 9.455 5.436a11.183 11.183 0 01-8.118-4.115A3.944 3.944 0 002.555 6.58a3.922 3.922 0 01-1.783-.493C.729 7.912 2.037 9.62 3.932 10a3.948 3.948 0 01-1.78.067 3.942 3.942 0 003.68 2.736A7.92 7.92 0 010 14.434a11.151 11.151 0 006.038 1.77c7.314 0 11.446-6.178 11.196-11.718A8.02 8.02 0 0019.2 2.447z","fill":"#52AFDD","fillRule":"nonzero"}));
}

TwitterLogo.defaultProps = {"width":"20","height":"17"};

module.exports = TwitterLogo;

TwitterLogo.default = TwitterLogo;
